import { useEffect, useSyncExternalStore } from 'react';

type ToastTone = 'success' | 'error' | 'info';

interface ToastEntry {
  id: number;
  message: string;
  tone: ToastTone;
}

let _id = 0;
let _toasts: ToastEntry[] = [];
const _listeners = new Set<() => void>();

function notify() { _listeners.forEach((fn) => fn()); }

export function toast(message: string, tone: ToastTone = 'info') {
  _toasts = [..._toasts, { id: ++_id, message, tone }];
  notify();
}

toast.success = (message: string) => toast(message, 'success');
toast.error = (message: string) => toast(message, 'error');

function dismiss(id: number) {
  _toasts = _toasts.filter((t) => t.id !== id);
  notify();
}

function subscribe(fn: () => void) {
  _listeners.add(fn);
  return () => { _listeners.delete(fn); };
}

function getSnapshot() { return _toasts; }

export function Toaster() {
  const toasts = useSyncExternalStore(subscribe, getSnapshot);

  return toasts.length > 0 ? (
    <div className="toast-container" aria-live="polite">
      {toasts.map((t) => (
        <ToastItem key={t.id} entry={t} />
      ))}
    </div>
  ) : null;
}

function ToastItem({ entry }: { entry: ToastEntry }) {
  useEffect(() => {
    const timer = setTimeout(() => dismiss(entry.id), 4000);
    return () => clearTimeout(timer);
  }, [entry.id]);

  return (
    <div className={`toast toast--${entry.tone}`} role="status">
      <span>{entry.message}</span>
      <button className="toast__close" onClick={() => dismiss(entry.id)} aria-label="Fermer">&times;</button>
    </div>
  );
}
